import { Button } from "@/components/ui/button";
import { useDialogModal } from "@/hook/handle-modal/hooks/actions";
import { RefreshCw } from "lucide-react";
import { DASHBOARD_LABELS } from "../messages";
import { DeliveryStatusEnum, ShippingRecipient } from "../types";
import { ResendModal } from "./resend-modal";

interface ResendButtonProps {
  kindLabel: string;
  recipient: ShippingRecipient;
}

export function ResendButton({
  kindLabel,
  recipient,
}: ResendButtonProps): JSX.Element | null {
  const { handleModal } = useDialogModal();

  if (recipient.status === DeliveryStatusEnum.DELIVERED) return null;

  const blockedByHardBounce: boolean =
    recipient.status === DeliveryStatusEnum.HARD_BOUNCE;

  const openResendModal = (): void => {
    handleModal({
      isOpen: true,
      title: DASHBOARD_LABELS.RESEND_TITLE(kindLabel),
      element: (
        <ResendModal kindLabel={kindLabel} recipient={recipient} />
      ),
    });
  };

  return (
    <span
      title={
        blockedByHardBounce
          ? DASHBOARD_LABELS.RESEND_BLOCKED_TOOLTIP
          : undefined
      }
      tabIndex={blockedByHardBounce ? 0 : undefined}
    >
      <Button
        variant="outline"
        size="sm"
        className="h-8"
        disabled={blockedByHardBounce}
        onClick={openResendModal}
      >
        <RefreshCw className="mr-1 h-3.5 w-3.5" />
        {DASHBOARD_LABELS.RESEND}
      </Button>
    </span>
  );
}
